export function getPropByPath<T = unknown>(object: Record<string, unknown> | undefined, path: string | undefined): T | undefined {
	if (!object)
		return undefined;

	if (path === undefined)
		return object as T;

	if (path === '.' || path === '' || path === 'this')
		return object as T;

	if (path.includes('.')) {
		const parts = path.split('.');
		let value: unknown = object;

		for (const part of parts) {
			if (value === undefined)
				break;

			value = (value as Record<string, unknown>)[part];
		}

		return value as T;
	}

	return object[path] as T;
}

export function setPropByPath(object: Record<string, unknown>, path: string | undefined, value: unknown): void {
	if (path === undefined)
		return;

	if (path === '.' || path === '' || path === 'this')
		return;

	if (path.includes('.')) {
		const parts = path.split('.');
		let target: Record<string, unknown> = object;

		for (let i = 0; i < parts.length - 1; i++) {
			if (target[parts[i]] === undefined)
				target[parts[i]] = {};

			target = target[parts[i]] as Record<string, unknown>;
		}

		target[parts[parts.length - 1]] = value;
	} else {
		object[path] = value;
	}
}
